module.exports = __webpack_public_path__ + "img/Mount1.5acfc1f1.jpg";